































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { ICatalogFilterItemInfo } from '~/assets/interfaces/catalog'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
  },
})
export default class ComponentCatalogFilterInfo extends Vue {
  @Prop({ type: Object, default: () => {} }) item!: ICatalogFilterItemInfo

  private mounted(): void {
    this.$nextTick(() => {
      if (this.item.type === 'script' && this.item.script) {
        const scriptContent: HTMLElement = this.$refs
          .scriptContent as HTMLElement
        const script: HTMLElement = document.createElement('script')
        script.dataset.b24Form = this.item.script.b24Form
        script.innerHTML = this.item.script.html
        ;(scriptContent as HTMLElement).appendChild(script)
      }
    })
  }
}
